import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

/**
 * 导出数据为 Excel 文件
 * @param {Array} data - 要导出的数据
 * @param {Array} headers - 表头配置
 * @param {string} fileName - 文件名（不含扩展名）
 */
export const exportToExcel = async (data, headers, fileName = 'export') => {
  // 创建工作簿
  const workbook  = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet 1');
  
  // 添加表头
  worksheet.columns = headers.map(header => ({
    header: header.title, // 表头显示名称
    key: header.key,      // 数据字段名
    width: header.width || 20, // 列宽（可选）
  }));



  // 添加数据行
  data.forEach(item => {
    worksheet.addRow(item);
  });
  
  //var row = 2;
  // if(data.length>0){
  //     for (let i = 0; i < data.length; i++) {
  //         var imgUrl      = data[i].image;
  //         const parsed    = await parseImageData(imgUrl);
  //         const imageId   = workbook.addImage({
  //                           base64: parsed.base64,
  //                           extension: parsed.extension,
  //         });

  //         worksheet.addImage(imageId, 'A'+row);

  //         row++;

  //     }
  // }


  // 生成 Excel 文件
  const buffer = await workbook.xlsx.writeBuffer();

  // 保存文件
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, `${fileName}${new Date().getTime()}.xlsx`);
};


// 修改后的解析函数
const parseImageData = async (imgData) => {
    if (!imgData) return null;

    // 处理URL情况
    if (imgData.startsWith('http')) {
        const dataURL = await urlToBase64(imgData);
        if (!dataURL) return null;
        const [header, base64] = dataURL.split(';base64,');
        const extension = header.split('/')[1];
        return { base64, extension };
    }

    // 原有处理dataURL的逻辑
    if (imgData.startsWith('data:image')) {
        const [header, base64] = imgData.split(';base64,');
        if (!header || !base64) return null;
        const extension = header.split('/')[1];
        return { base64, extension };
    }

    return null;
};


// 新增：将图片URL转换为base64
const urlToBase64 = async (url) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error('图片转换失败:', error);
        return null;
    }
};